import { useState } from 'react';
import { InputAdornment, Stack, Typography } from '@mui/material';
import { EmailIcon } from '@/components/Icons/Icons';
import { CustomTextfield } from '@/components/CustomTextfield/styles';
import { DeleteButton, LeftSide, SettingBox, WhiteWrapper } from '../styles';
import theme from '@/theme';
import { useAuthStore } from '@/stores/authStore';
import { verifyBeforeUpdateEmail } from 'firebase/auth';
import useAlertStore from '@/stores/alertStore';
import ChangeEmailModal from '@/components/CustomModal/ChangeEmailModal';
import { FIREBASE_ERRORS } from '@/helpers/errors';

const ChangeEmail = () => {
  const [open, setOpen] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const { currentUser } = useAuthStore();
  const { showAlert } = useAlertStore();

  const toggleModal = () => {
    setOpen(!open);
  };

  const handleChangeEmail = async () => {
    if (!currentUser) {
      showAlert('No user is currently logged in', 'error');
      return;
    }

    try {
      localStorage.setItem('pendingNewEmail', newEmail);
      await verifyBeforeUpdateEmail(currentUser, newEmail);

      showAlert('A verification email has been sent to your new email address', 'success');
    } catch (error) {
      const typedError = error as { code: string };
      if (typedError.code === FIREBASE_ERRORS.AUTH_REQUIRES_RECENT_LOGIN) {
        showAlert('Please re-login before to update your email', 'error');
        return;
      }
      showAlert(`Failed to update email`, 'error');
    }
  };

  return (
    <>
      <SettingBox>
        <LeftSide>
          <Typography variant="body1" fontWeight="700">
            Change Email Address
          </Typography>
        </LeftSide>

        <WhiteWrapper gap="1.5rem">
          <Typography variant="body2" color={theme.palette.neutral.greyFont}>
            You're about to change the email address associated with your account. By clicking 'Change Email,' you’ll
            receive a message at your new email with a link to confirm this update. Please double-check that the new
            email is correct, as it will be used for all future account communications.
          </Typography>

          <Stack gap="0.5rem">
            <Typography variant="body2" fontWeight="700">
              Change Email Address
            </Typography>
            <CustomTextfield
              variant="outlined"
              size="small"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Stack>

          <DeleteButton variant="outlined" color="error" onClick={toggleModal}>
            Change Email
          </DeleteButton>
        </WhiteWrapper>
      </SettingBox>

      <ChangeEmailModal open={open} handleClose={toggleModal} onConfirm={handleChangeEmail} />
    </>
  );
};

export default ChangeEmail;
